const lang = {
  AA: '아파르어',
  AB: '압하스어',
  AF: '아프리칸스어',
  AK: '아칸어',
  AM: '암하라어',
  AR: '아랍어',
  AN: '아라곤어',
  AS: '아삼어',
  AV: '아바르어',
  AE: '아베스타어',
  AY: '아이마라어',
  AZ: '아제르바이잔어',
  BA: '바시키르어',
  BM: '밤바라어',
  BE: '벨로루시어',
  BN: '방글라데시어',
  BH: '비하르어',
  BI: '비슬라마',
  BO: '티베트어',
  BS: '보스니아어',
  BR: '브르타뉴어',
  BG: '불가리아어',
  CA: '카탈루냐어',
  CS: '체코어',
  CH: '차모로어',
  CE: '체첸어',
  CU: '슬라브어 (고대 교회)',
  CV: '추바슈어',
  KW: '콘월어',
  CO: '코르시카어',
  CR: '크리어',
  CY: '웨일스어',
  DA: '덴마크어',
  DE: '독일어',
  DV: '디베히어',
  DZ: '종카어',
  EL: '그리스어 (현대) (1453년 이후)',
  EN: '영어',
  EO: '에스페란토어',
  ET: '에스토니아어',
  EU: '바스크어',
  EE: '에웨어',
  FO: '페로스어',
  FA: '페르시아어',
  FJ: '피지어',
  FI: '핀란드어',
  FR: '프랑스어',
  FY: '프리지아어 (서부)',
  FF: '풀라어',
  GD: '고이델어',
  GA: '아일랜드어',
  GL: '갈리시아어',
  GV: '맨어',
  GN: '파라과이 과라니',
  GU: '구자라트어',
  HT: '아이티어',
  HA: '하우사어',
  HE: '히브리어',
  HZ: '헤레로어',
  HI: '힌두어',
  HO: '히리 모투',
  HR: '크로아티아어',
  HU: '헝가리어',
  HY: '아르메니아어',
  IG: '이그보어',
  IO: '이도',
  II: '쓰촨 이어',
  IU: '이누이트어',
  IE: '인테르링구어 (옥시덴탈)',
  IA: '인테르링구아 (국제보조어협회)',
  ID: '인도네시아어',
  IK: '이누피아크어',
  IS: '아이슬란드어',
  IT: '이탈리아어',
  JV: '자와어',
  JA: '일본어',
  KL: '그린란드어',
  KN: '칸나다어',
  KS: '카슈미르어',
  KA: '조지아어',
  KR: '카누리어',
  KK: '카자흐어',
  KM: '중부 크메르어',
  KI: '키쿠유어',
  RW: '르완다어',
  KY: '키르기스어',
  KV: '코미어',
  KG: '콩고어',
  KO: '한국어',
  KJ: '콰냐마어',
  KU: '쿠르드어',
  LO: '라오어',
  LA: '라틴어',
  LV: '라트비아어',
  LI: '림뷔르흐어',
  LN: '링갈라어',
  LT: '리투아니아어',
  LB: '룩셈부르크어',
  LU: '루바카탕가어',
  LG: '간다어',
  MH: '마셜어',
  ML: '말라얄람어',
  MR: '마라티어',
  MK: '마케도니아어',
  MG: '말라가시어',
  MT: '몰타어',
  MN: '몽골어',
  MI: '마오리어',
  MS: '말레이어',
  MY: '버마어',
  NA: '나우루',
  NV: '나바호어',
  NR: '은데벨레어 (남)',
  ND: '은데벨레어 (북)',
  NG: '은동가어',
  NE: '네팔어',
  NL: '네덜란드어',
  NN: '뉘노리스크',
  NB: '보크몰',
  NO: '노르웨이어',
  NY: '니안자어',
  OC: '오크어 (1500년 이후)',
  OJ: '오지브와어',
  OR: '오리야어',
  OM: '오로모어',
  OS: '오세트어',
  PA: '펀자브어',
  PI: '팔리어',
  PL: '폴란드어',
  PT: '포르투갈어',
  PS: '파슈토어',
  QU: '케추아어족',
  RM: '로만슈어',
  RO: '루마니아어',
  RN: '룬디어',
  RU: '러시아어',
  SG: '상고어',
  SA: '산스크리트어',
  SI: '싱할라어',
  SK: '슬로바키아어',
  SL: '슬로베니아어',
  SE: '사미어 (북)',
  SM: '사모아어',
  SN: '쇼나어',
  SD: '신디어',
  SO: '소말리아어',
  ST: '소토어 (남)',
  ES: '스페인어',
  SQ: '알바니아어',
  SC: '사르데냐어',
  SR: '세르비아어',
  SS: '스와티어',
  SU: '순다어',
  SW: '스와힐리어',
  SV: '스웨덴어',
  TY: '타히티어',
  TA: '타밀어',
  TT: '타타르어',
  TE: '텔루구어',
  TG: '타지크어',
  TL: '타갈로그어',
  TH: '태국어',
  TI: '티그리냐어',
  TO: '통가어 (통가 제도)',
  TN: '츠와나어',
  TS: '총가어',
  TK: '투르크멘어',
  TR: '터키어',
  TW: '알칸어군',
  UG: '위구르어',
  UK: '우크라이나어',
  UR: '우르두어',
  UZ: '우즈베크어',
  VE: '벤다어',
  VI: '베트남어',
  VO: '볼라퓌크',
  WA: '왈론어',
  WO: '월로프어',
  XH: '코사어',
  YI: '이디시어',
  YO: '요루바어',
  ZA: '좡어',
  ZH: '중국어',
  ZU: '줄루어'
};

export default lang;
